var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"d-flex justify-space-between align-center",class:_vm.colClass},[(!_vm.isPropsTitle)?_c('span',{staticClass:"field-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }